import { updateUserApi, uploadFile } from "api/network";
import { IMAGES } from "assets";
import { AxiosProgressEvent } from "axios";
import { IconButton } from "components/buttons";
import { Icons } from "components/icons";
import { Loading } from "components/loading";
import { ImageResizeModal } from "components/modal/image-resize-modal";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useBoundStore } from "store";
import { COLOR_PALETTE } from "theme";
import { STORAGE_KEYS, createMediaUrl, storage } from "utils";

export const Header = () => {
  const navigate = useNavigate();
  const { userInfo, headerTitle } = useBoundStore();

  const [loading, setLoading] = useState(false);

  const inputRef = useRef<HTMLInputElement>(null);

  const [value, setValue] = useState("");

  const [fileString, setFileString] = useState<string | null>(null);

  const checkFileIsValid = (file?: File): boolean => {
    const acceptedSize = 20000000;
    const acceptedTypes = ["image/png", "image/jpeg"];
    if (file) {
      if (!acceptedTypes.includes(file.type)) {
        // setError("نوع فایل انتخابی صحیح نمیباشد.");
        return false;
      }
      if (file.size > acceptedSize) {
        // setError("حجم فایل انتخابی بیش از حجم مجاز است.");
        return false;
      }
      // setError("");
      return true;
    }
    return false;
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);

    if (!!e.target.files?.length) {
      const file = e.target.files[0];

      if (checkFileIsValid(file)) {
        var reader = new FileReader();
        var url = reader.readAsDataURL(file);

        reader.onloadend = function (e) {
          setFileString(reader.result as string);
        };
      }
    }
  };

  const updateProgressing = (progressEvent: AxiosProgressEvent) => {
    const p = (progressEvent.loaded * 100) / (progressEvent.total || 1);
    // setProgressed(p.toFixed());
  };

  const onUpload = async (file: File) => {
    try {
      setLoading(true);
      setFileString(null);

      const { id, hash } = await uploadFile(file, updateProgressing);
      await updateUserApi({ ProfilePhotoId: id, ProfilePhotoHash: hash });
      window.location.reload();
    } catch (error) {
      setValue("");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!fileString) {
      setValue("");
    }
  }, [fileString]);

  return (
    <header className="flex items-center h-14 px-6">
      <div className="flex-1 ">
        {!!headerTitle ? (
          <div className="flex items-center">
            <IconButton
              size="xs"
              contentColor="black"
              backgroundColor="#00000000"
              iconName="ArrowRight"
              buttonProps={{ onClick: () => navigate(-1) }}
            />
            <div className="font-bold text-gray-400">{headerTitle}</div>
          </div>
        ) : (
          <div className="flex items-center gap-1.5">
            <div className="dropdown dropdown-bottom flex items-center">
              <div
                tabIndex={0}
                role="button"
                className="btn btn-circle btn-sm bg-primary mb-1 overflow-hidden"
              >
                {userInfo?.ProfilePhotoId && (
                  <img
                    src={
                      createMediaUrl({
                        id: userInfo.ProfilePhotoId,
                        hash: userInfo.ProfilePhotoHash,
                      }) ?? undefined
                    }
                  />
                )}
              </div>
              <ul
                tabIndex={0}
                className="dropdown-content z-[1] menu py-2 px-0 shadow bg-base-100 rounded-box w-52"
              >
                <li className="border-b border-[#F5F5F5]">
                  <button
                    className="rounded-none"
                    onClick={() => {
                      inputRef.current && inputRef.current.click();
                    }}
                  >
                    <div className="flex items-center gap-2 text-[#555]">
                      <Icons name="PersonOutlined" color={"#555"} />
                      تغییر عکس پروفایل
                    </div>
                  </button>
                </li>
                <li>
                  <button
                    className="rounded-none"
                    onClick={() => {
                      storage.remove(STORAGE_KEYS.TOKEN);
                      window.location.reload();
                    }}
                  >
                    <div className="flex items-center gap-2 text-error">
                      <Icons name="Exit" color={COLOR_PALETTE.error} />
                      خروج
                    </div>
                  </button>
                </li>
              </ul>
            </div>
            {userInfo?.Name && <div className="h-1.5 w-px bg-[#D3D3D3]" />}
            <div className="text-sm font-bold text-gray-400">
              {userInfo?.Name}
            </div>
          </div>
        )}
      </div>
      <div className="w-6 h-6">
        <img src={IMAGES.LOGOS.HAMILA_CENTER[24]} alt="" />
      </div>
      <input
        ref={inputRef}
        className={"w-0 h-0"}
        value={value}
        type={"file"}
        onChange={handleChange}
        multiple={false}
        accept="image/png, image/jpeg"
        hidden
      />
      <ImageResizeModal
        open={!!fileString}
        cropShape="round"
        imageSource={fileString}
        onClose={() => setFileString(null)}
        onSubmit={onUpload}
      />
      <Loading open={loading} />
    </header>
  );
};
